import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";

export const hasAnyError = (data: CptCodesTableRowModel[]): boolean => {
  return data.some(
    (row) =>
      row.startFrom.hasError ||
      row.endAt.hasError ||
      row.visits.hasError ||
      row.remainingVisits.hasError ||
      row.visitsAllowed.hasError ||
      row.jCodes.hasError,
  );
};
